namespace $.$$ {
	export class $shm_hitalama_settings_git extends $.$shm_hitalama_settings_git {
		token( next?: string ) { return this.$.$shm_hitalama_settings.github_token( next ) }
		owner( next?: string ) { return this.$.$shm_hitalama_settings.github_owner( next ) }
	}
}
